"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetadataByTargetKind = exports.TargetKind = exports.Platforms = void 0;
var Platforms;
(function (Platforms) {
    Platforms["BUSINESS_MANAGER"] = "business-manager";
    Platforms["DEV_PORTAL"] = "dev-portal";
    Platforms["DEV_CENTER"] = "dev-center";
    Platforms["ACCOUNT_MANAGER"] = "account-manager";
    Platforms["ENTERPRISE"] = "enterprise";
    Platforms["MOBILE"] = "mobile";
    Platforms["STUDIO_DASHBOARD"] = "studio-dashboard";
    Platforms["CHANNELS"] = "channels";
    Platforms["DATA_TOOLS"] = "data-tools";
    Platforms["PSP_BACKOFFICE"] = "psp-backoffice";
    Platforms["RISE_PLATFORM_ACCOUNT_DASHBOARD"] = "rise-platform-account-dashboard";
})(Platforms = exports.Platforms || (exports.Platforms = {}));
var TargetKind;
(function (TargetKind) {
    TargetKind["NPM"] = "npm";
    TargetKind["STATIC"] = "static";
    TargetKind["DOCKER"] = "docker";
    TargetKind["PROTO"] = "proto";
    TargetKind["SERVERLESS"] = "serverless";
    TargetKind["DEVCENTER"] = "devcenter";
    TargetKind["SOURCE_MAPS_UPLOAD"] = "source-maps-upload";
    TargetKind["RUBYGEM"] = "rubygem";
})(TargetKind = exports.TargetKind || (exports.TargetKind = {}));
function getMetadataByTargetKind(targetKind) {
    if (targetKind === TargetKind.DOCKER || targetKind === TargetKind.SERVERLESS) {
        return { needsDepsPublishContent: true };
    }
    return { needsDepsPublishContent: false };
}
exports.getMetadataByTargetKind = getMetadataByTargetKind;
//# sourceMappingURL=artifact-description.js.map